import React, { useState } from 'react';
import api from '../services/api';
import { AlertCircle, Save, Send } from 'lucide-react';

const AgendaWorkflow = ({ formData, setFormData, committeeMembers }) => {
  const [sending, setSending] = useState(false);
  const [sendResult, setSendResult] = useState(null);
  const [agendaFile, setAgendaFile] = useState(null);

  return (
    <div className="workflow-form">
      <div className="alert-banner alert-info">
        <AlertCircle className="alert-icon" />
        <div>
          <h3 className="alert-title">Committee Agenda Creation</h3>
          <p className="alert-text">
            Only Health & Safety Advisor or Committee Member Delegates can create agendas
          </p>
        </div>
      </div>

      <div className="form-grid">
        <div className="form-group">
          <label className="form-label">Date of Meeting</label>
          <input
            type="date"
            value={formData.meetingDate || ''}
            onChange={(e) => setFormData({...formData, meetingDate: e.target.value})}
            className="form-input"
          />
        </div>
        <div className="form-group">
          <label className="form-label">Time of Meeting</label>
          <input
            type="time"
            value={formData.meetingTime || ''}
            onChange={(e) => setFormData({...formData, meetingTime: e.target.value})}
            className="form-input"
          />
        </div>
      </div>

      <div className="form-group">
        <label className="form-label">Location of Meeting</label>
        <input
          type="text"
          value={formData.location || ''}
          onChange={(e) => setFormData({...formData, location: e.target.value})}
          placeholder="Enter meeting location"
          className="form-input"
        />
      </div>

      <div className="form-group">
        <label className="form-label">Link to Previous Committee Meeting</label>
        <select className="form-select">
          <option value="">Select previous meeting</option>
          <option value="1">Meeting - Oct 15, 2025</option>
          <option value="2">Meeting - Sep 20, 2025</option>
          <option value="3">Meeting - Aug 18, 2025</option>
        </select>
      </div>

      <div className="form-group">
        <label className="form-label">Attach Safety Advisor Report (PDF)</label>
        <input
          type="file"
          accept=".pdf"
          onChange={(e) => {
            const file = e.target.files && e.target.files[0];
            setAgendaFile(file || null);
          }}
          className="form-input"
        />
      </div>

      <div className="form-actions">
        <button className="btn-secondary" disabled={sending}>
          <Save className="btn-icon" />
          Save Draft
        </button>
        <button
          className="btn-primary"
          disabled={sending}
          onClick={async () => {
            try {
              setSending(true);
              setSendResult(null);
              // Prepare members list for invitations
              const members = (committeeMembers || []).map(m => ({
                name: m.name,
                email: m.email || m.id, // support either email field or id-as-email
                department: m.department
              }));

              // If a PDF is attached, upload it first to get a URL
              let agendaPdfUrl = formData.agendaPdfUrl || null;
              if (agendaFile) {
                try {
                  const fd = new FormData();
                  fd.append('file', agendaFile);
                  // backend should store to S3 (or disk) and return a public/secured URL
                  const uploadRes = await api.post('/api/committeeMeetings/upload-agenda', fd, {
                    headers: { 'Content-Type': 'multipart/form-data' },
                  });
                  agendaPdfUrl = uploadRes.data?.url || uploadRes.data?.agendaPdfUrl || agendaPdfUrl;
                } catch (uploadErr) {
                  console.error('Failed to upload agenda PDF:', uploadErr);
                  alert(uploadErr?.response?.data?.error || uploadErr.message || 'Failed to upload agenda PDF');
                  setSending(false);
                  return;
                }
              }

              // Prepare payload for invitations including agendaPdfUrl
              const payload = {
                meetingDate: formData.meetingDate || '',
                meetingTime: formData.meetingTime || '',
                location: formData.location || '',
                previousMeetingId: formData.previousMeetingId || null,
                agendaPdfUrl,
                createdBy: formData.createdBy || null,
                members
              };

              const res = await api.post('/api/committeeMeetings/create-and-invite', payload);
              setSendResult(res.data);
              alert(`Invites sent: ${res.data?.invitesSent || 0}`);
            } catch (e) {
              console.error('Failed to send invitations:', e);
              alert(e?.response?.data?.error || e.message || 'Failed to send invitations');
            } finally {
              setSending(false);
            }
          }}
        >
          <Send className="btn-icon" />
          {sending ? 'Sending…' : 'Send Agenda'}
        </button>
      </div>
      {sendResult && (
        <div className="mt-3" style={{ color: '#065f46' }}>
          Meeting created. ID: {sendResult.meetingId}
        </div>
      )}
    </div>
  );
};

export default AgendaWorkflow;